/**
 * Set's the value on an object
 * @param object
 * @param dotPath
 * @param value
 * @example
 * setValueOnDotPath({}, 'My.Path.Item', 3);
 *
 * returns: {
 *      My: {
 *          Path: {
 *              Item: 3
 *          }
 *      }
 * }
 */
export function setValueOnDotPath(object: Object, dotPath: string, value: any) {
	// No path, return
	if (dotPath == null) return;

	let tempObj = object;
	const pathParts = dotPath.split('.');

	pathParts.forEach((pathPart, i) => {
		// Assign the value if it's the last part of the path
		if (pathParts.length - 1 === i) {
			tempObj[pathPart] = value;
		} else {
			// Create a nested object
			tempObj[pathPart] = tempObj[pathPart] || {};
			tempObj = tempObj[pathPart];
		}
	});
}
